module.exports = __webpack_public_path__ + "img/Aurora_K_uv_sleeve.107361f2.svg";